export const tableOption = {
    dialogDrag: true,
    border: true,
    indexLabel: '序号',
    stripe: true,
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: true,
    printBtn: true,
    viewBtn: true,
    searchMenuSpan: 6,
    column: [
            {
            label: 'ID',
            prop: 'id',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入ID',
                        trigger: 'blur'
                    },
                                    {
                        max: 36,
                        message: '长度在不能超过36个字符'
                    },
                ]
        },
            {
            label: '任务ID(代理商任务ID | 车队长任务ID | 司机任务ID)',
            prop: 'taskId',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入任务ID(代理商任务ID | 车队长任务ID | 司机任务ID)',
                        trigger: 'blur'
                    },
                                    {
                        max: 36,
                        message: '长度在不能超过36个字符'
                    },
                ]
        },
            {
            label: '评价文字',
            prop: 'appraiseText',
            sortable: true,
            rules: [
                                    {
                        max: 500,
                        message: '长度在不能超过500个字符'
                    },
                ]
        },
            {
            label: '评价图片url，多个使用英文逗号分开',
            prop: 'imgUrls',
            sortable: true,
            rules: [
                                    {
                        max: 1024,
                        message: '长度在不能超过1024个字符'
                    },
                ]
        },
            {
            label: '类型：1=代理商任务、2=车队长任务、3=司机任务',
            prop: 'type',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入类型：1=代理商任务、2=车队长任务、3=司机任务',
                        trigger: 'blur'
                    },
                                    {
                        max: 1,
                        message: '长度在不能超过1个字符'
                    },
                ]
        },
            {
            label: '创建ID',
            prop: 'createId',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入创建ID',
                        trigger: 'blur'
                    },
                                    {
                        max: 36,
                        message: '长度在不能超过36个字符'
                    },
                ]
        },
            {
            label: '创建日期时间',
            prop: 'createDatetime',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入创建日期时间',
                        trigger: 'blur'
                    },
                                ]
        },
            {
            label: '评价结果1',
            prop: 'score1',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '评价结果2',
            prop: 'score2',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '评价结果3',
            prop: 'score3',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '评价结果4',
            prop: 'score4',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '评价结果5',
            prop: 'score5',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '积分',
            prop: 'point',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: '评价人ID',
            prop: 'systemUserId',
            sortable: true,
            rules: [
                    {
                        required: true,
                        message: '请输入评价人ID',
                        trigger: 'blur'
                    },
                                    {
                        max: 36,
                        message: '长度在不能超过36个字符'
                    },
                ]
        },
            ]
}
